// extracted by mini-css-extract-plugin
export default {"imageWrapper":"EK-z","twoColumnImage":"FK-z"};